export const GET_SECTIONS = 'GET_SECTIONS'
export const GET_SECTION = 'GET_SECTION'
export const DELETE_SECTION = 'DELETE_SECTION'
export const ADD_SECTION = 'ADD_SECTION'
export const DELETE_MANY_SECTIONS = 'DELETE_MANY_SECTION'
export const UPDATE_SECTION = 'UPDATE_SECTION'
